"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_rainbow_components_1 = require("react-rainbow-components");
var InternalOverlay_1 = __importDefault(require("react-rainbow-components/components/InternalOverlay"));
var manageTab_1 = __importDefault(require("react-rainbow-components/libs/manageTab"));
var hooks_1 = require("@rainbow-modules/hooks");
var UniversalForm_1 = __importDefault(require("../UniversalForm"));
var positionResolver_1 = __importDefault(require("./helpers/positionResolver"));
var styled_1 = require("./styled");
var UniversalFormOverlay = function (_a) {
    var triggerElementRef = _a.triggerElementRef, isOpen = _a.isOpen, fields = _a.fields, initialValues = _a.initialValues, onOpened = _a.onOpened, onSumbit = _a.onSumbit, onRequestClose = _a.onRequestClose, submitButtonLabel = _a.submitButtonLabel, cancelButtonLabel = _a.cancelButtonLabel, rest = __rest(_a, ["triggerElementRef", "isOpen", "fields", "initialValues", "onOpened", "onSumbit", "onRequestClose", "submitButtonLabel", "cancelButtonLabel"]);
    var uniqueId = hooks_1.useUniqueIdentifier('form');
    var containerRef = react_1.useRef();
    var hasFocus = react_1.useRef(false);
    hooks_1.useOutsideClick(function () { return containerRef.current; }, function () {
        if (hasFocus.current && onRequestClose) {
            onRequestClose();
        }
    }, isOpen);
    var handleOpen = function () {
        if (containerRef.current)
            containerRef.current.focus();
        if (onOpened)
            onOpened();
    };
    var handleKeyPress = function (event) {
        if (isOpen && event.key === 'Escape' && onRequestClose) {
            onRequestClose();
        }
        if (event.key === 'Tab' && containerRef.current !== undefined) {
            manageTab_1.default(containerRef.current, event);
        }
    };
    var handleFocus = function (event) {
        var _a;
        if (event.target === containerRef.current || ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
            hasFocus.current = true;
        }
    };
    var handleBlur = function (event) {
        var _a;
        if (event.target === containerRef.current || ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
            hasFocus.current = false;
        }
    };
    var Fields = fields || (function () { return null; });
    return (react_1.default.createElement(InternalOverlay_1.default, { isVisible: isOpen, triggerElementRef: triggerElementRef, onOpened: handleOpen, positionResolver: positionResolver_1.default, render: function () {
            return (react_1.default.createElement(styled_1.StyledContainer, { ref: containerRef, onKeyDown: handleKeyPress, onFocus: handleFocus, onBlur: handleBlur, tabIndex: "-1" },
                react_1.default.createElement(styled_1.StyledContent, null,
                    react_1.default.createElement(UniversalForm_1.default, { id: uniqueId, initialValues: initialValues, onSubmit: onSumbit },
                        react_1.default.createElement(Fields, __assign({}, rest)))),
                react_1.default.createElement(styled_1.StyledFooter, null,
                    react_1.default.createElement(react_rainbow_components_1.Button, { className: "rainbow-m-right_small", label: "Cancel", size: "small", variant: "neutral", onClick: onRequestClose }, cancelButtonLabel),
                    react_1.default.createElement(react_rainbow_components_1.Button, { label: "Save", size: "small", variant: "brand", type: "submit", form: uniqueId }, submitButtonLabel))));
        } }));
};
exports.default = UniversalFormOverlay;
//# sourceMappingURL=index.js.map